import { ele } from "cables-shared-client";
import api from "./api.js";
import web from "./index.js";

export default class Favs
{
    follow(userid)
    {
        api.post(
            "follow/" + userid,
            (res) =>
            {
            },
            (res) =>
            {
                if (res.followstate) ele.byId("follow-button").innerText = "Following";
                else ele.byId("follow-button").innerText = "Follow";
            }
        );
    }

    loadFavsAndUpdateDom(referenceId, type = null)
    {
        const referenceType = type || "project";
        let apiUrl = "favs/" + referenceId;
        if (referenceType) apiUrl += "/" + referenceType;
        api.get(apiUrl, (likes) =>
        {
            const data = {};
            data.likes = likes;
            data.likeColumns = Math.max(Math.ceil(likes.length / 10), 1);
            if (likes)
            {
                if (likes.length > 0)
                {
                    const view = ele.byId("fav-hover-view");
                    web.setHandleBarHtml("likelist", data, view);
                }
                const numFavs = ele.byQueryAll(".num-favs");
                numFavs.forEach((numFav) =>
                {
                    numFav.innerText = likes.length;
                });
            }
        });
    }

    updateFav(state, projectId, type)
    {
        if (state)
        {
            ele.byQueryAll(".fav-text-and-icon .fav-icon")
                .forEach((icon) =>
                {
                    icon.classList.remove("icon-heart");
                    icon.classList.add("icon-heart-fill");
                });
        }
        else
        {
            ele.byQueryAll(".fav-text-and-icon .fav-icon")
                .forEach((icon) =>
                {
                    icon.classList.add("icon-heart");
                    icon.classList.remove("icon-heart-fill");
                });
        }
        this.loadFavsAndUpdateDom(projectId, type);
    }

    toggleFav(id, type = "project")
    {
        const apiUrl = "fav/toggle/" + id;
        api.post(
            apiUrl,
            {
                "type": type
            },
            (res) =>
            {
                this.updateFav(res.favstate, id, type);
            }
        );
    }

    showFavToggle(favEle)
    {
        if (favEle)
        {
            const id = favEle.dataset.id;
            const type = favEle.dataset.type || "project";
            const isFav = favEle.dataset.isfav && (favEle.dataset.isfav !== "false");
            const numFavs = favEle.dataset.numfavs;
            web.setHandleBarHtml("favtoggle", { "reference": { "_id": id }, "type": type, "isFav": isFav, "numFavs": numFavs }, favEle);
        }
    }
}
